import { getDocs, collection } from "@firebase/firestore";
import { hideLoading, setItemStatusList, showLoading } from "./item-status-list-slice";

export const getItemStatusService = async (dispatch, db, coll) => {
    dispatch(showLoading());
    try {
        await getDocs(collection(db, coll))
        .then((querySnapshot) => {
            const data = querySnapshot.docs
                .map((doc) => ({...doc.data(), id:doc.id}));
            dispatch(setItemStatusList(data));
        });
    } catch(e) {
        console.error("ItemStatusList getItemStatusService error: ", e);
    }
    dispatch(hideLoading());
};